import {UserProfileContact} from 'api/gen/UserProfileContact';

import {UserContactsTableType} from '../../types/user-contacts-table-type';

/**
 * Maps contact API rows into the contacts table representation.
 *
 * @param row Source API row with the stored contact details.
 * @returns The table row used by the contacts tab.
 */
export const rowMapper = ({contactType, userContactId, value}: UserProfileContact): UserContactsTableType => ({
    contactType,
    userContactId,
    value,
    id: userContactId,
});
